<template>
  <div>
    <section class="main" v-if="ProductPoint">
      <div class="container">
        <div class="img-box">
          <img :src="SiteUrl + ProductPoint.Image" alt="" />
        </div>
        <div class="box">
          <!-- 0517 新增 title-box div -->
          <div class="title-box">
            <h1>{{ ProductPoint.Name }}</h1>
            <div class="price">
              <p v-if="ProductPoint.Price > 0">NTD{{ ProductPoint.Price }}</p>
              <p v-if="ProductPoint.Price == 0"></p>
              <p>{{ $t("點數") }}</p>
              <p>{{ ProductPoint.Bonus }}</p>
            </div>
            <!-- 0607 新增 hr -->
            <hr />
            <!-- 0607 新增 ul -->
            <ul class="main-box" v-if="ProductPoint.NeedPlateNumber">
              <li>
                <div>{{ $t("車牌號碼") }}</div>
              </li>
              <div>
                <input
                  type="text"
                  class="form-control"
                  id="plateNumber"
                  name="plateNumber"
                  :placeholder="$t('請輸入車牌號碼')"
                  v-model="PlateNumber"
                />
              </div>
            </ul>
            <hr v-if="ProductPoint.NeedPlateNumber" />
            <!-- 0608 新增 -->
            <div>
              <div class="btn-box" v-if="!IsLogin">
                <router-link :to="{ name: 'Login' }" tag="button">
                  {{ $t("請先登入") }}
                </router-link>
              </div>
              <div class="btn-box" v-if="IsLogin && !HasCardMember">
                <router-link :to="{ name: 'CardBind' }" tag="button">
                  {{ $t("請先註冊卡片會員") }}
                </router-link>
              </div>
              <div
                class="btn-box"
                v-if="IsLogin && HasCardMember && RemainingBonus < 0"
              >
                {{ $t("無可用的套票點數") }}
              </div>
              <div
                class="btn-box"
                v-if="
                  IsLogin &&
                  HasCardMember &&
                  RemainingBonus >= 0 &&
                  RemainingBonus < ProductPoint.Bonus
                "
              >
                {{ $t("點數不足(剩餘" + RemainingBonus + "點)") }}
              </div>
              <div
                class="btn-box"
                v-if="
                  IsLogin &&
                  HasCardMember &&
                  RemainingBonus >= ProductPoint.Bonus
                "
              >
                <button @click="gotoPay">
                  {{ $t("立即兌換(剩餘" + RemainingBonus + "點)") }}
                </button>
              </div>
            </div>
          </div>
          <hr />
          <!-- 0517 新增 text-box div -->
          <div class="text-box">
            <!-- 0517 新增 h2 -->
            <h2>{{ $t("商品內容") }}</h2>
            <p class="text" v-html="ProductPoint.Content"></p>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import CryptoJS from "crypto-js";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    類型: "類型",
    實體卡片: "實體卡片",
    天數: "天數",
    天: "天",
    贈送點數: "贈送點數",
    點: "點",
    優惠卷代碼: "優惠卷代碼",
    請輸入優惠券碼: "請輸入優惠券碼",
    總計: "總計",
    "總計(套用優惠卷)": "總計(套用優惠卷)",
    "套票啟用日(購買後無法更改)": "套票啟用日(購買後無法更改)",
    付款方式: "付款方式",
    線上刷卡: "線上刷卡",
    請先登入: "請先登入",
    請先註冊卡片會員: "請先註冊卡片會員",
    立即購買: "立即購買",
    "您的卡片尚未通過審核或尚未啟用，無法購買此類票卡":
      "您的卡片尚未通過審核或尚未啟用，無法購買此類票卡",
    "已有啟用中的票卡，無法進行購買": "已有啟用中的票卡，無法進行購買",
    方案內容: "方案內容",
    錯誤: "錯誤",
    "取得會員資訊過程發生錯誤, 請稍後再試一次":
      "取得會員資訊過程發生錯誤, 請稍後再試一次",
    確定: "確定",
    "請稍候...": "請稍候...",
    "訂單建立過程發生錯誤, 請稍後再試一次":
      "訂單建立過程發生錯誤, 請稍後再試一次",
    交易完成: "交易完成",
    關閉: "關閉",
    繼續: "繼續",
    "付款完成後，將前往訂單頁面確認套票購買狀態":
      "付款完成後，將前往訂單頁面確認套票購買狀態",
    點數: "點數",
    車牌號碼: "車牌號碼",
    請輸入車牌號碼: "請輸入車牌號碼",
    無可用的套票點數: "無可用的套票點數",
  },
  en: {
    類型: "Type",
    實體卡片: "Physical card",
    天數: "Number of days",
    天: "Day",
    贈送點數: "Bonus points",
    點: "Point",
    優惠卷代碼: "Coupon code",
    請輸入優惠券碼: "Please enter the coupon code",
    總計: "Total",
    "總計(套用優惠卷)": "Total (apply the coupon)",
    "套票啟用日(購買後無法更改)":
      "Package ticket enabling day (you cannot change after buying)",
    付款方式: "Payment mode",
    線上刷卡: "Online payment",
    請先登入: "Please login first",
    請先註冊卡片會員: "Please register for card membership first",
    立即購買: "Buy now",
    "您的卡片尚未通過審核或尚未啟用，無法購買此類票卡":
      "Your card has not been approved or enabled to purchase this ticket",
    "已有啟用中的票卡，無法進行購買":
      "A ticket already in use cannot be purchased",
    方案內容: "Contents of the scheme",
    錯誤: "Error",
    "取得會員資訊過程發生錯誤, 請稍後再試一次":
      "An error occurred during getting the membership information. Please try again later",
    確定: "Confirm",
    "請稍候...": "Wait a second please...",
    "訂單建立過程發生錯誤, 請稍後再試一次":
      "An error occurred during the order creation. Please try again later",
    交易完成: "Transaction done",
    關閉: "Close",
    繼續: "Continue",
    "付款完成後，將前往訂單頁面確認套票購買狀態":
      'After the payment. Please click "Confirm" to go to the Order Page to confirm the status of package ticket',
    點數: "Points",
    車牌號碼: "License Plate No.",
    請輸入車牌號碼: "Please Enter",
    無可用的套票點數: "No points available.",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "MProductBuy",
  i18n,
  data() {
    return {
      SiteUrl: "",
      ProductPoint: {},
      HasCardMember: false,
      IsLogin: Storage.isKey("ek_login_token"),
      PlateNumber: "",
      RemainingBonus: -1,
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/ProductPoint",
        {
          params: {
            token: Storage.get("ek_login_token"),
            PPId: this.$route.params.PPId,
          },
        }
      )
      .then((response) => {
        this.SiteUrl = response.data.SiteUrl;
        this.ProductPoint = response.data.ProductPoint;
        this.HasCardMember = response.data.HasCardMember;
        this.RemainingBonus = response.data.RemainingBonus;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("package-main");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  updated: function () {},
  methods: {
    gotoPay() {
      let that = this;
      // 顯示請稍候
      that.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      // 進入交易環節
      $.ajax({
        url:
          that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/CreateOrder",
        type: "post",
        data: {
          ProductType: 3,
          PayType: 3,
          PPId: that.ProductPoint.PPId,
          token: Storage.get("ek_login_token"),
          plateNumber: that.PlateNumber,
          BuyCount: 1,
        },
        dataType: "json",
        async: false,
        error: function () {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: that.$t("訂單建立過程發生錯誤, 請稍後再試一次"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              title: that.$t("交易完成"),
              icon: "success",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
              willClose: function () {
                // 轉到首頁
                that.$router.push({
                  name: "PointOrderList",
                  params: { o_maas_so_nbr: res.o_maas_so_nbr },
                });
              },
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            if (res.toekn_error) {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                willClose: function () {
                  // 移除登入資訊
                  Storage.remove("ek_login_token");
                  // 回到首頁
                  that.$router.push({
                    name: "Home",
                    params: {},
                  });
                },
              });
            } else {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            }
          }
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProductPoint.vue